// Copyright 2005-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>. All Rights Reserved.

var solitaire = require('./solitaire').games;
var flower = require('./flower');
var piles = require('./piles'), in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.beleaguered = class extends flower {
    constructor(variant,ui) {
        super(variant, ui, false);
        if (variant == "fortress") {
            this.layout = this.fortress_layout();
            this.work_piles = () => 10;
            this.work_pile = this.fortress_work_pile;
        }
        this.init_flower(variant, ui);
        for (let p=0; p<this.work.length; p++) {
            this.work[p].yoffset = 0;
            this.work[p].xoffset = 30/90;
            if (!(p&1)) {
                this.work[p].xoffset *= -1;
                this.work[p].origin = { x:3, y:0 };
            }
        }
    }
    static variants = { fortress: {} };

    work_piles() { return 8; }

    fortress_work_pile() {
        return class extends super.work_pile() {
            in_order(a,b) { return in_numeric_order(a,b) || in_numeric_order(b,a) }
            can_drag(index) {
                    return in_order_by(this.in_order, this.pile, index)
                           && this.pile.length - index <= drag_max_given_free(this.game.work); }
            accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.work, this) ? 1 :
                           this.pile.length && this.in_order(cards[0], this.top())                            ? 2 : 0;
            }
        };
    }

    reserve_pile() {
        return class extends super.reserve_pile() {
            constructor(div,game) {
                super(div, game, false); // don't show empty pile maker
            }
        }
    }


    deal(deck) {
            for (var c in deck)
                deck[c].face = up;
            this.reserve.pile = deck;
            var c,g=0;
            for (var y=0; y<6; y++)
                for (var w in this.work) {
                    if (!this.reserve.pile.length) break;
                    while ((c = this.reserve.pop()).rank == ace)
                        this.good[g++].push(c);
                    this.work[w].push(c);
                }
            for (var c=0; c<this.reserve.pile.length; c++)
                this.reserve.pile[c].face = up;
    }

    layout = grid(["work1", { x: +3 }, "good1", "work2"],
                  ["work3", { x: +3 }, "good2", "work4"],
                  ["work5", { x: +3 }, "good3", "work6"],
                  ["work7", { x: +3 }, "good4", "work8"]);

    fortress_layout() {
        return grid(["work1", { x: +3 }, undefined, "work2"],
                    ["work3", { x: +3 }, "good1",   "work4"],
                    ["work5", { x: +3 }, "good2",   "work6"],
                    ["work7", { x: +3 }, "good3",   "work8"],
                    ["work9", { x: +3 }, "good4",   "work10"]);
    }
}

module.exports = solitaire.beleaguered;
// Copyright 2005-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>. All Rights Reserved.

var solitaire = require('./solitaire').games;
var flower = require('./flower');
var piles = require('./piles'), in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.beleaguered = class extends flower {
    constructor(variant,ui) {
        super(variant, ui, false);
        if (variant == "fortress") {
            this.layout = this.fortress_layout();
            this.work_piles = () => 10;
            this.work_pile = this.fortress_work_pile;
        }
        this.init_flower(variant, ui);
        for (let p=0; p<this.work.length; p++) {
            this.work[p].yoffset = 0;
            this.work[p].xoffset = 30/90;
            if (!(p&1)) {
                this.work[p].xoffset *= -1;
                this.work[p].origin = { x:3, y:0 };
            }
        }
    }
    static variants = { fortress: {} };

    work_piles() { return 8; }

    fortress_work_pile() {
        return class extends super.work_pile() {
            in_order(a,b) { return in_numeric_order(a,b) || in_numeric_order(b,a) }
            can_drag(index) {
                    return in_order_by(this.in_order, this.pile, index)
                           && this.pile.length - index <= drag_max_given_free(this.game.work); }
            accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.work, this) ? 1 :
                           this.pile.length && this.in_order(cards[0], this.top())                            ? 2 : 0;
            }
        };
    }

    reserve_pile() {
        return class extends super.reserve_pile() {
            constructor(div,game) {
                super(div, game, false); // don't show empty pile maker
            }
        }
    }


    deal(deck) {
            for (var c in deck)
                deck[c].face = up;
            this.reserve.pile = deck;
            var c,g=0;
            for (var y=0; y<6; y++)
                for (var w in this.work) {
                    if (!this.reserve.pile.length) break;
                    while ((c = this.reserve.pop()).rank == ace)
                        this.good[g++].push(c);
                    this.work[w].push(c);
                }
            for (var c=0; c<this.reserve.pile.length; c++)
                this.reserve.pile[c].face = up;
    }

    layout = grid(["work1", { x: +3 }, "good1", "work2"],
                  ["work3", { x: +3 }, "good2", "work4"],
                  ["work5", { x: +3 }, "good3", "work6"],
                  ["work7", { x: +3 }, "good4", "work8"]);

    fortress_layout() {
        return grid(["work1", { x: +3 }, undefined, "work2"],
                    ["work3", { x: +3 }, "good1",   "work4"],
                    ["work5", { x: +3 }, "good2",   "work6"],
                    ["work7", { x: +3 }, "good3",   "work8"],
                    ["work9", { x: +3 }, "good4",   "work10"]);
    }
}

module.exports = solitaire.beleaguered;
